import { getSlotsRouteUrls } from '@bcraft-frontend-lib/slots'

import type { SlotPlace } from '../types'

export const SLOTS_ROUTE_URLS = getSlotsRouteUrls<SlotPlace>()